import { Link } from "react-router-dom";
import FairPriceBadge from "../FairPriceBadge";
import RiskBadge from "../RiskBadge";
import DealerVerificationBadge from "../DealerVerificationBadge";
import { formatPriceCop, formatVehicleTitle } from "../../../utils/automapListing/listingFormatters";

/**
 * Vehicle context header for full checklist page (Milestone 12).
 */
export default function VehicleChecklistContextCard({ listing, checklistVm, detailHref, copy = {} }) {
  if (!listing) return null;

  const title = formatVehicleTitle(listing);
  const priceLabel = listing.priceCop != null ? formatPriceCop(listing.priceCop) : null;

  return (
    <section className="vehicle-checklist-context" aria-label={copy.contextEyebrow || "Vehicle context"}>
      <p className="vehicle-checklist-context__eyebrow">{copy.contextEyebrow || "Checklist for"}</p>
      <h2 className="vehicle-checklist-context__title">{title}</h2>
      <div className="vehicle-checklist-context__meta">
        {priceLabel ? <span>{priceLabel}</span> : null}
        {listing.mileageKm != null ? <span>{Math.round(listing.mileageKm / 1000)}k km</span> : null}
        {listing.dealerName ? <span>{listing.dealerName}</span> : null}
      </div>
      <div className="vehicle-checklist-context__badges">
        <FairPriceBadge listing={listing} size="small" variant="compact" hideIfNoData />
        <RiskBadge listing={listing} size="small" variant="compact" hideIfLow />
        <DealerVerificationBadge listing={listing} size="small" variant="compact" context="card" />
      </div>
      {checklistVm?.checklistSummary ? (
        <p className="vehicle-checklist-context__summary">{checklistVm.checklistSummary}</p>
      ) : null}
      {detailHref ? (
        <Link to={detailHref} className="btn btn-soft vehicle-checklist-context__back">
          {copy.backToVehicle || "Back to vehicle"}
        </Link>
      ) : null}
    </section>
  );
}
